<button [attr.data-active]="active()" class="group">
  <span class="size-5" [class]="icon()"></span>
  <div class="flex flex-col text-sm *:text-sm">
    <ng-content />
  </div>
  @if (showArrow()) {
    <span class="ml-auto icon-[mdi--chevron-right] size-4 opacity-60"></span>
  }
</button>
